import type { CommandItem } from '@/components/CommandPalette';
import type { TFunction } from 'i18next';
import type { NavigateFunction } from 'react-router-dom';

interface BuildArgs {
  locale: string;
  isAuthenticated: boolean;
  t: TFunction;
  navigate: NavigateFunction;
}

/**
 * 构造命令面板的 items（导航 + 控制台 + 账户三组）。
 * t 为 common ns（无 keyPrefix），跨 ns 用 'dashboard:xxx' 全限定 key。
 */
export function buildCommandItems({ locale, isAuthenticated, t, navigate }: BuildArgs): CommandItem[] {
  const go = (path: string) => () => navigate(`/${locale}${path}`);
  const navGroup = t('commandPalette.groupNavigation');
  const dashGroup = t('commandPalette.groupDashboard');
  const accountGroup = t('commandPalette.groupAccount');

  const items: CommandItem[] = [
    { id: 'nav-home', label: t('nav.home'), group: navGroup, action: go('') },
    { id: 'nav-marketplace', label: t('nav.marketplace'), group: navGroup, action: go('/marketplace') },
    { id: 'nav-about', label: t('footer.about'), group: navGroup, action: go('/about') },
  ];

  if (isAuthenticated) {
    items.push(
      { id: 'dash-home', label: t('nav.dashboard'), group: dashGroup, action: go('/dashboard') },
      { id: 'dash-sessions', label: t('dashboard:tabs.mySessions'), group: dashGroup, action: go('/dashboard/sessions') },
      { id: 'dash-orders', label: t('userMenu.orders'), group: dashGroup, action: go('/dashboard/orders') },
      { id: 'dash-wallet', label: t('userMenu.wallet'), group: dashGroup, action: go('/dashboard/wallet') },
      { id: 'dash-agents', label: t('userMenu.myAgents'), group: dashGroup, action: go('/dashboard/agents') },
    );
  } else {
    items.push(
      { id: 'acc-login', label: t('nav.signIn'), group: accountGroup, action: go('/login') },
      { id: 'acc-register', label: t('nav.register'), group: accountGroup, action: go('/register') },
    );
  }

  return items;
}
